// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__kRId4","addWidgetButton":"Header_addWidgetButton__64Z3U","dashboardTabs":"Header_dashboardTabs__7TWXL","active":"Header_active__3glXd"};